export default "__VITE_ASSET__Bigddr5m__"